import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, BUSINESS_TYPES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allBusinessType',
  url: `${BUSINESS_TYPES_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
